/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import React, { ReactNode } from 'react';

import { ISocialShareViewProps } from '@msdyn365-commerce-modules/social-share/src/modules/social-share/./social-share';
import { FaShareAlt } from 'react-icons/fa';

export const SocialShareView: React.FC<ISocialShareViewProps> = props => {
    const { SocialShareList, SocialShareItemElements, SocialShareItem, SocialShare } = props;
    if (SocialShareItemElements.length === 0) {
        props.context.telemetry.error('Social media list is empty, module wont render');
        return null;
    }
    return (
        <Module {...SocialShare}>
            <div className='ms-social-share-label'>
                <span className='ms-social-share-text'>Share this resource</span>
                <span className='ms-social-share-icon moe-icon-share'>
                    <FaShareAlt title='Share this resource'></FaShareAlt>
                </span>
            </div>
            <Node {...SocialShareList}>
                {SocialShareItemElements.map((SocialShareElement: ReactNode, index: number) => {
                    return (
                        <Node {...SocialShareItem} key={index}>
                            {SocialShareElement}
                        </Node>
                    );
                })}
            </Node>
        </Module>
    );
};

export default SocialShareView;
